import { Navigate, Route, Routes } from 'react-router';
import { PublicRoute } from '@/layout/PublicLayout';
import { ProtectedRoute } from '@/layout/ProtectedLayout';
import { LandingScreen } from '@/screens/landing/LandingScreen';
import { ORBDisplay } from '@/screens/orb-display/ORBDisplay';
import { AppScreen } from '@/types/common';
import { DeviceConfigLayout } from '@/layout/DeviceConfigLayout';
import { OnboardingScreen } from '@/screens/onboarding/OnboardingScreen';

const Routing = () => {
  return (
    <Routes>
      {/* Public routes - for unauthenticated users only */}
      <Route element={<PublicRoute />}>
        <Route path={AppScreen.LANDING} element={<LandingScreen />} />
      </Route>

      {/* Protected routes - for authenticated users only */}
      <Route element={<ProtectedRoute />}>
        <Route path={AppScreen.GET_STARTED} element={<OnboardingScreen />} />

        <Route element={<DeviceConfigLayout />}>
          <Route path={AppScreen.DASHBOARD} element={<ORBDisplay />} />
        </Route>
        <Route
          path="*"
          element={<Navigate to={AppScreen.DASHBOARD} replace />}
        />
      </Route>
    </Routes>
  );
};

export default Routing;
